import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/storage";

import testFirebaseConfig from "./firebaseConfig.sit.js";
import prodFirebaseConfig from "./firebaseConfig.prod.js";

let firebaseConfig;
if (import.meta.env.VITE_ENV === "test") {
  firebaseConfig = testFirebaseConfig;
} else {
  firebaseConfig = prodFirebaseConfig;
}

const firebaseApp = firebase.initializeApp(firebaseConfig);

const emulatorHost = "127.0.0.1";
const localDevHost = "localhost";
const useEmulator =
  window.location.hostname === emulatorHost ||
  (window.location.hostname === localDevHost &&
    import.meta.env.VITE_EMULATOR === "true");

if (useEmulator) {
  firebase.auth().useEmulator(`http://${emulatorHost}:9099`);
  firebase.firestore().useEmulator(emulatorHost, 8082);
  firebase.storage().useEmulator(emulatorHost, 9199);
}

firebase.auth().setPersistence("local");

export default firebaseApp;
